export function buildSuggestions(rawQuery, books, genres = []) {
  const q = rawQuery.trim().toLowerCase();
  if (!q) return [];

  const titleMatches = [];
  const authorMatches = [];
  const seenAuthors = new Set();

  books.forEach((b) => {
    if (b.title?.toLowerCase().includes(q)) {
      titleMatches.push({ type: 'book', label: b.title, sub: b.author?.name || '', to: `/book/${b.slug}` });
    }
    const authorName = b.author?.name;
    if (
      authorName &&
      authorName.toLowerCase().includes(q) &&
      !seenAuthors.has(authorName)
    ) {
      seenAuthors.add(authorName);
      authorMatches.push({ type: 'author', label: authorName, sub: 'Author', to: `/authors/${b.author.slug}` });
    }
  });

  const genreMatches = genres
    .filter((g) => g.toLowerCase().includes(q))
    .map((g) => ({ type: 'genre', label: g, sub: 'Genre', to: `/shop?genre=${encodeURIComponent(g)}` }));

  const pools = [titleMatches, authorMatches, genreMatches];
  const merged = [];
  let i = 0;
  while (pools.some((p) => p.length)) {
    const pool = pools[i % pools.length];
    if (pool.length) merged.push(pool.shift());
    i += 1;
  }
  return merged;
}
